var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.54 51.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc506;}.cls-2{fill:#cd9411;}.cls-3{fill:#575758;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.58,10.13H3.38A3.38,3.38,0,0,0,0,13.51V38.83a3.38,3.38,0,0,0,3.38,3.38H45.58A3.38,3.38,0,0,0,49,38.83V13.51A3.38,3.38,0,0,0,45.58,10.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.58,5.06H26.29a3.38,3.38,0,0,1-2.81-1.5L22.11,1.5A3.38,3.38,0,0,0,19.3,0H3.38A3.38,3.38,0,0,0,0,3.38V13.51a3.38,3.38,0,0,1,3.38-3.38H45.58A3.38,3.38,0,0,1,49,13.51V8.44A3.38,3.38,0,0,0,45.58,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.41,38.54a1.42,1.42,0,0,0-1.3-.83H53.42V19.2A1.42,1.42,0,0,0,52,17.78H46.31a1.42,1.42,0,0,0-1.42,1.42V37.71H39.19a1.42,1.42,0,0,0-1.07,2.36l10,11.39a1.42,1.42,0,0,0,2.14,0l10-11.39A1.42,1.42,0,0,0,60.41,38.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicDownload);
export default __webpack_public_path__ + "static/media/basic-download.9d7f6d17342ae7fa212810016917e584.svg";
export { ForwardRef as ReactComponent };